import { default as deserialize } from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'
import FormErrors from 'app/utils/form_errors'

const INITIAL_ITEM = null

export default {
  namespaced: true,

  state: {
    item: INITIAL_ITEM
  },

  getters: {
    meteredBilling: (state) => state.item
  },

  mutations: {
    meteredBillingFetched(state, { meteredBilling }) {
      state.item = meteredBilling
    },

    resetState: (state) => {
      state.item = INITIAL_ITEM
    }
  },

  actions: {
    async fetchMeteredBilling({ commit }) {
      try {
        const response = await fetch({
          url: `/api/metered-billing`
        })
        const meteredBilling = await deserialize(response.data)

        commit('meteredBillingFetched', { meteredBilling })
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    },

    async updateMeteredBilling({ commit, state }, changes) {
      try {
        const response = await update({
          url: `/api/metered-billing`,
          type: 'metered-billing',
          record: state.item,
          patch: true,
          changes
        })

        const meteredBilling = await deserialize(response.data)

        commit('meteredBillingFetched', { meteredBilling })

        return meteredBilling
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
